import { useParams } from 'react-router';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useSnackbar } from 'notistack';
import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Grid, TextField } from '@mui/material';

import { Street } from '@/types';
import { useCreateStreetMutation } from '@/services';
import { messages } from '@/utils/helpers';

export interface CreateStreetProps extends DialogProps {
  onClose(): void;
}

const CreateStreet: React.FC<CreateStreetProps> = ({ onClose, ...props }) => {
  const { regionId, districtId, localityId } = useParams<{
    regionId: string;
    districtId: string;
    localityId: string;
  }>();

  const { enqueueSnackbar } = useSnackbar();

  const [createStreet, createStreetResponse] = useCreateStreetMutation();

  const { values, errors, touched, handleSubmit, handleChange } = useFormik<Street>({
    initialValues: {
      name: '',
    },
    validationSchema: yup.object().shape({
      name: yup.string().required(messages.form.REQUIRED),
    }),
    async onSubmit(street, { resetForm }) {
      try {
        await createStreet({
          ...street,
          region_id: Number(regionId),
          district_id: Number(districtId),
          locality_id: Number(localityId),
        }).unwrap();

        onClose();
        resetForm();
      } catch (error) {
        enqueueSnackbar(error.data, { variant: 'error' });
      }
    },
  });

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">Добавить улицу</DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <Grid container spacing={3}>
            <Grid item lg={6} md={6} xs={12}>
              <TextField
                name="name"
                label="Наименование"
                placeholder="Введите значение"
                value={values.name}
                onChange={handleChange}
                disabled={createStreetResponse.isLoading}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name ? errors.name : ''}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            type="button"
            color="secondary"
            variant="outlined"
            disabled={createStreetResponse.isLoading}
            onClick={onClose}
          >
            Закрыть
          </Button>

          <Button type="submit" variant="contained" disabled={createStreetResponse.isLoading}>
            Добавить
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateStreet;
